import { OutcomeOptimizationLayoutRoute } from './-components';
import { createFileRoute } from '@tanstack/react-router';

type OutcomeOptimizationSearch = {
  /** Legacy: a run used to live in the query string. The page replaces it with the path form. */
  run_id?: string;
};

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/outcome-optimization')({
  component: OutcomeOptimizationLayoutRoute,
  // validateSearch replaces the whole search, so spread incoming params to keep global ones (masq_account_id, cmd-search, …).
  // oxlint-disable-next-line local-rules/no-unsafe-dictionary-type -- validateSearch is handed unparsed search input, and the pass-through carries those same unvalidated values
  validateSearch: (search: Record<string, unknown>): Record<string, unknown> & OutcomeOptimizationSearch => ({
    ...search,
    run_id: typeof search.run_id === 'string' ? search.run_id : undefined,
  }),
});
